(function changePasswordControllerDefinition() {

    'use strict';

    angular.module('Profile')
        .controller('ChangePasswordController', [
             '$scope', 'authExtend', '$translate', '$q', 'config', '$state', '$stateParams', 'errorsExtend', 'diff',
             'alerts', 'login',
            function changePasswordController($scope, authExtend, $translate, $q, config, $state, $stateParams, errors, diff,
                                              alerts, login) {

                $scope.perfil = {
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                };

                $scope.pw = $scope.perfil.password;

                $scope.save = function () {

                    if (!$scope.changePasswordForm.$valid) {
                        $scope.changePasswordForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return authExtend.changePassword($scope.perfil).then(function () {
                        errors.showSuccess('PasswordChanged');
                        login.logOut();
                        $state.go('inicio');
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.cancel = function () {
                    $state.go("inicio");
                };

            }

        ]);
})();